<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
        <div class="d-flex justify-end" v-if="is_admin">
  <v-btn 
    v-if="!is_admin"
    color="brand onBrand--text"
    dark
    small
    style="margin-top:-15px; margin-right:-0.5em; border-radius:8px;"
    @click="videoDialog = true"
  >
    <v-icon left>mdi-youtube</v-icon>
    Watch Tutorial
  </v-btn>
</div>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Edit Learner Attendance</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn class="mb-2 button" color="warning" :loading="delete_load" @click="add_attendance_card = true">Add
            Attendance</v-btn>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col sm="4" md="4" cols="12">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Select Academic Year" outlined @change="getDivisionData(status)" />
          </v-col>
          <v-col sm="4" md="4" cols="12" v-if="learner_info!=''">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="learner" :items="learner_info"
              item-text="learner" item-value="learner_id" label="Learner" @change="getAttendanceDetails(this)"
              return-object outlined persistent-hint hint="Select Learner" />
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="attendance_list.length > 0">
        <v-data-table :headers="headers" :items="attendance_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Attendance Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.is_present`]="{ item }">
            <v-avatar color="success" size="30" v-if="item.is_present">
              <span class="white--text headline">P</span>
            </v-avatar>

            <v-avatar v-else color="error" size="30">
              <span class="white--text headline">A</span>
            </v-avatar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <v-switch v-model="item.is_present" @change="saveUpdateAttendance(item)"></v-switch>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-avatar size="35">
                <v-icon class="mr-4 v-icon-size" color="red" @click="deleteAttendance(item)">mdi-trash-can</v-icon>
              </v-avatar>
            </div>
          </template>

        </v-data-table>
      </v-card>
      <v-dialog v-model="add_attendance_card" max-width="900px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Mark Student Attendance</strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12">
            <v-card class="box">
              <v-row justify="center" dense>

                <v-col sm="4" md="4" cols="12">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
                    item-value="id" label="Select Academic Year" outlined @change="getDivisionData()" />
                </v-col>


                <v-col sm="4" md="4" cols="12" v-if="learner_info!=''">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="learner_attendance"
                    :items="learner_info" item-text="learner" item-value="learner_id" label="Learner"
                    @change="getAttendanceDetes(learner_attendance)" return-object outlined persistent-hint
                    hint="Select Learner" />
                </v-col>
                <v-col cols="12" sm="3" v-if="dates_list.length > 0">
                  <v-icon color="error">*</v-icon>
                  <v-autocomplete color="#0F2027" dense rounded required v-model="attendance_date" :items="dates_list"
                    item-text="date" label="Dates" item-value="date" outlined persistent-hint hint="Select Date"
                    multiple />
                </v-col>
                <v-col cols="12" sm="4" v-if="dates_list.length > 0">
                  <br><br>
                  <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                    <v-radio label="Present" value="true" color="#0f2027"></v-radio>
                    <v-radio label="Absent" value="false" color="#0f2027"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row justify="center" dense>
                <v-btn class="button" @click="saveSingleAttendance()" :loading="delete_load"
                  v-if="this.learner_attendance && this.attendance_date">save</v-btn>
                <v-btn class="button" @click="add_attendance_card = false">Close</v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-card>
      </v-dialog>



    </v-container>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span>Edit Student Attendance Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/9FroDy4oMWM?si=FJ_hzdW0TdEUcboc"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

    data: () => ({
      is_admin: false,
      loader:false,radios:null,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      title: "",
      videoDialog: false, 
      is_admin:false,
      // extraBreadcrumbItems: [
     

      // ],
      // breadcrumbClass: "breadcrumb-style1",
      description:"",
      learner_info:[],learner:"",
      headers:[
      { text: "Sr. No.", value: "srno" },
      { text: "Division", value: "division" },
      { text: "Standard", value: "standard" },
      { text: "Date", value: "date" },
     // { text: "Day No", value: "day_number" },
      { text: "Present/Absent", value: "is_present" },
      { text: "Mark Present/Absent", value: "edit" },
      { text: "Delete Attendance", value: "delete" },
      ],
      attendance_list:[],show_table:false,delete_load:false,add_attendance_card:false,learner_attendance:"",dates_list:[],attendance_date:[],ay_list:[],ay:""
  }),
   methods: {
     getDivisionData() {
            const data = {
                ay:this.ay
            }
            this.learner_info=[]
            axios
                .post("/Academics/editSingleStudentAttendance", data)
                .then((res) => {
                   if (res.data.flag == "Yes") {
                      this.learner_info=res.data.learner_info
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },
    getAttendanceDetes(item){
      this.dates_list=[]
       const formData = {
               // learner_id: item.learner_id,
                learner_division_id:item.learner_division_id
             };
        this.delete_load=true
         axios
        .post("/Academics/getAttendanceDetes", formData)
        .then(res => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("#4caf50", "Added Successfully"); // show snackbar on success
            this.dates_list = res.data.dates_list;
          } else {
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch(error => {
          sessionStorage.setItem("error-trace", res.data.error_trace);
          window.console.log(error);
        })
        .finally((
        ) => {
           this.delete_load=false
        });
    },
    saveSingleAttendance(){
       const formData = {
               // learner: this.learner_attendance.learner_id,
                learner_division_id: this.learner_attendance.learner_division_id,
                attendance_date:this.attendance_date,
                is_present:this.radios
             };
        this.delete_load=true
         axios
        .post("/Academics/saveSingleAttendance", formData)
        .then(res => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully"); // show snackbar on success
            this.attendance_list = res.data.learner_attendance_info;
            this.add_attendance_card=false,this.attendance_date=[]
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.delete_load=false
          this.add_attendance_card=false
        });
    },
       deleteAttendance(item){
      // alert('item'+item.divoff)
        if (!confirm("Are You Sure You Want To Delete This Date's Attendance...?"))
             return;
              const formData = {
                attendance_id: item.id,
             };
        this.delete_load=true
         axios
        .post("/Academics/deleteSingleAttendance", formData)
        .then(res => {
          if (res.data.flag == "Yes") {
            this.showSnackbar("#4caf50", "Deleted Successfully"); // show snackbar on success
            this.attendance_list = res.data.learner_attendance_info;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
        });
       },
       saveUpdateAttendance(item){
        const formData = {
            learner_attendance_id: item.id,
            is_present: item.is_present
        };
        axios
            .post("/Academics/saveUpdateAttendance", formData)
            .then((res) => {
                if (res.data.flag == "Yes") {
                    this.attendance_list = res.data.learner_attendance_info;
                    this.show_table = true;
                } else {
                    //   window.console.log(res.data.msg);
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                }
            })
            .catch((error) => {
                window.console.log(error);
            })
            .finally(() => {
                this.loader = false;
            });         
       },
       getAttendanceDetails(item){
         //  alert("item::"+item)
         this.loader=true
         const formData = {
                    learner: this.learner.learner_id,
                    learner_division_id: this.learner.learner_division_id
                };
                axios
                    .post("/Academics/getStudentAttendanceDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.attendance_list = res.data.learner_attendance_info;
                            this.show_table = true;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
       },
        onLoad() {
        axios
            .post("/Academics/studentAttendanceHome")
            .then((res) => {
                if (res.data.flag == "YES") {
                    this.ay_list=res.data.ay_list
                    this.learner_info=res.data.learner_info
                    this.ay=res.data.cay
                    if (res.data.is_admin !== undefined) {
                this.is_admin = res.data.is_admin;
            }
                } else {
                    //   window.console.log(res.data.msg);
                    this.showSnackbar("#b71c1c", "Something went wrong!");
                }
            })
            .catch((error) => {
                window.console.log(error);
            })
            .finally(() => {});
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>
